export default {
    content: {
        copyright: 'Copyright © 2020 Audacious Inquiry, LLC',
    },
};
